module.exports = __webpack_public_path__ + "img/bust dart to bust dart jumpsuit.acbdbd72.png";